import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { LocationsRouterStoreSelectors } from '../router';
import { DevicesOsUpdateStatusActions } from './index';

@Injectable({ providedIn: 'root' })
export class DevicesOsUpdateStatusResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectLocationId).pipe(
      filter((locationId): locationId is string => !!locationId),
      tap((locationId) => {
        this.store.dispatch(
          DevicesOsUpdateStatusActions.DevicesOsUpdateStatesResolverActions.osUpdateStatesRequested({
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
